import styled from 'styled-components';
import { transparentize } from 'polished';

import AvatarBase from 'react-avatar';
import { Card as CardBase } from 'components/Card/styles';
import { Form as FormBase } from '@unform/web';
import { CircularProgressbar } from 'react-circular-progressbar';

interface DropContainerProps {
  $isDragReject: boolean;
  $isDragActive: boolean;
}
interface AvatarProps {
  $inUpload: boolean;
}
export const Container = styled.div`
  width: -webkit-fill-available;
  width: -moz-available;
  display: grid;
  grid-template-columns: 1fr 2fr;
  /* display: flex;
  flex-direction: row; */
  ${CardBase} {
    flex: 2 2;
  }
`;

export const CardAvatar = styled.div`
  background: ${props => props.theme.cardBackgroud};
  margin-right: 15px;
  border-radius: 5px;
  height: calc(100vh - 90px);
  padding: 15px;
  flex: 1 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const Info = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  h5 {
    margin: 15px 0 7px;
    font-size: 1.14em;
    font-weight: 300;
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-size: 0.8125rem;
      margin-right: 5px;
    }

    strong {
      margin-left: 5px;
      font-size: 0.8125rem;
      font-weight: 600;
    }
  }
`;
export const ButtonUpload = styled.button`
  position: absolute;
  border: 0;
  padding: 0;
  margin: 0%;
  transition: all 0.3s ease;
  opacity: 0;
  top: 5.5rem;

  margin-left: -15px;
  border-radius: 50%;
  padding: 4px 6px;

  background-image: linear-gradient(
    to bottom left,
    ${props => props.theme.button.primary.out},
    ${props => props.theme.button.primary.in},
    ${props => props.theme.button.primary.out}
  ) !important;
  background-color: ${props => props.theme.button.primary.out};
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  svg {
    color: #fff;
    font-size: 24px;
  }
`;

export const ButtonRemove = styled.button`
  position: absolute;
  border: 0;
  padding: 0;
  margin: 0%;
  transition: all 0.3s ease;
  opacity: 0;
  top: 5.5rem;

  margin-left: -5rem;
  border-radius: 50%;
  padding: 4px 6px;

  background-image: linear-gradient(
    to bottom left,
    ${props => props.theme.button.secondary.out},
    ${props => props.theme.button.secondary.in},
    ${props => props.theme.button.secondary.out}
  ) !important;
  background-color: ${props => props.theme.button.secondary.out};
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  svg {
    color: #fff;
    font-size: 24px;
  }
`;

export const ButtonUploadError = styled.button`
  position: absolute;
  border: 0;
  padding: 0;
  margin: 0%;
  transition: all 0.3s ease;
  opacity: 0;
  top: 5.5rem;

  margin-left: -15px;
  border-radius: 50%;
  padding: 4px 6px;

  background-image: linear-gradient(
    to bottom left,
    ${props => props.theme.button.danger.out},
    ${props => props.theme.button.danger.in},
    ${props => props.theme.button.danger.out}
  ) !important;
  background-color: ${props => props.theme.button.danger.out};
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  svg {
    color: #fff;
    font-size: 24px;
  }
`;

export const AvatarContent = styled.div`
  text-align: center;
  caret-color: transparent;
  justify-content: center;
  text-transform: none;
  margin-top: 25px;

  header {
    div {
      position: absolute;
      height: 100px;
      width: 250px;

      background: rgba(225, 78, 202, 0.6);
      background: linear-gradient(
        90deg,
        rgba(225, 78, 202, 0.6) 0,
        rgba(225, 78, 202, 0)
      );
      filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);

      &:nth-child(1) {
        transform: rotate(150deg);
        margin-top: -90px;
        margin-left: -50px;
      }

      &:nth-child(2) {
        transform: rotate(30deg);
        margin-top: -40px;
        margin-left: -45px;
      }

      &:nth-child(3) {
        transform: rotate(170deg);
        margin-top: -70px;
        right: -45px;
      }

      &:nth-child(4) {
        transform: rotate(150deg);
        margin-top: -25px;
        right: -45px;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;

  section {
    margin: 30px 0 15px;
    padding-bottom: 3px;
    border-bottom: 1px solid
      ${props => transparentize(0.7, props.theme.fontColor)};
  }
`;

export const Upload = styled.div`
  &:hover ${ButtonUpload} {
    opacity: 1;
  }

  &:hover ${ButtonRemove} {
    opacity: 1;
  }
`;

export const Avatar = styled(AvatarBase)<AvatarProps>`
  position: relative;

  filter: ${props =>
    props.$inUpload ? 'blur(1px) grayscale(100%)' : 'blur(0px)'};

  div {
    cursor: pointer;
    span {
      color: ${transparentize(0.3, '#fff')};
      font-weight: 300;
      font-size: 1.5rem;
    }
  }
`;

export const DropContainer = styled.div<DropContainerProps>`
  ${ButtonUpload} {
    opacity: ${props => (props.$isDragActive ? '1' : '0')};
  }

  ${ButtonUploadError} {
    opacity: ${props => (props.$isDragReject ? '1' : '0')};
  }
`;

export const Form = styled(FormBase)`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  section {
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
    &:first-of-type {
      margin: 0px 0 15px 0;
    }
  }
`;

export const CincularContainer = styled(CircularProgressbar)`
  position: absolute;

  top: 2.5rem;
  margin-left: -3.9rem;

  opacity: 1;
`;

export const WidgetContent = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    margin-left: 0;
    margin-bottom: 0.5rem;
  }
`;
